import addDeleteGetLocalStorage from "../GlobalModule/addDeleteGetLocalStorage";
import { STORAGE } from "./Enums";

export const CheckToken = () => {
  let value = addDeleteGetLocalStorage(STORAGE.TOOLED_UP_LOCAL_DATA, {}, "get", "single");
  return value;
};
